import React from 'react'

const SpinnerBTN = () => {
    return (
        <>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
        </>
    )
}

export default SpinnerBTN